import ShellHeader from '../components/ShellHeader';
import warrantywiseLogo from '../assets/warrantywise-logo.svg';
import warrantyfirstLogo from '../assets/warrantyfirst-logo.png';

// true = included, false = not included, string = note (e.g. 'Optional', 'Engine only')
const warrantyWisePlans = [
  { key: 'pp', name: 'Platinum Plus', eligibility: 'Up to 4 yrs / 40,000 mi' },
  { key: 'p',  name: 'Platinum',      eligibility: 'Up to 8 yrs / 80,000 mi' },
  { key: 'g',  name: 'Gold',          eligibility: 'Up to 10 yrs / 100,000 mi' },
  { key: 's',  name: 'Silver',        eligibility: 'Up to 12 yrs / 120,000 mi' },
  { key: 'b',  name: 'Bronze',        eligibility: 'Up to 14 yrs / 140,000 mi' },
];

const warrantyWiseFeatures = [
  { label: 'All Mechanical Parts',    plans: { pp: true,        p: true,        g: false,       s: false,       b: false } },
  { label: 'All Electrical Parts',    plans: { pp: true,        p: true,        g: false,       s: false,       b: false } },
  { label: 'Engine',                  plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Gearbox',                 plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Clutch',                  plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Drive Train',             plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Differential',            plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Drive Belts',             plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Gaskets',                 plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Consequential Damage',    plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'No Excess',               plans: { pp: true,        p: true,        g: true,        s: true,        b: true  } },
  { label: 'Steering & Suspension',   plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Cooling System',          plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Turbocharger',            plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Intercooler',             plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Wastegate',               plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Braking System',          plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'ABS',                     plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Electrical System',       plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Fuel System',             plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Oil Seals',               plans: { pp: true,        p: true,        g: true,        s: true,        b: false } },
  { label: 'Parts Replaced in Pairs', plans: { pp: true,        p: true,        g: true,        s: false,       b: false } },
  { label: 'Car Hire',                plans: { pp: true,        p: true,        g: true,        s: false,       b: false } },
  { label: 'Recovery',                plans: { pp: true,        p: true,        g: true,        s: false,       b: false } },
  { label: 'ECU',                     plans: { pp: true,        p: true,        g: true,        s: 'Eng. only', b: false } },
  { label: 'Air Bag System',          plans: { pp: true,        p: true,        g: 'Optional',  s: 'Optional',  b: false } },
  { label: 'Emissions',               plans: { pp: true,        p: true,        g: 'Optional',  s: 'Optional',  b: false } },
  { label: 'MOT Failure',             plans: { pp: true,        p: true,        g: 'Optional',  s: 'Optional',  b: false } },
  { label: 'Multimedia',              plans: { pp: true,        p: true,        g: 'Optional',  s: 'Optional',  b: false } },
  { label: 'Air Conditioning',        plans: { pp: true,        p: 'Optional',  g: 'Optional',  s: 'Optional',  b: false } },
];

const warrantyFirstPlans = [
  { key: 'exc',  name: 'Exclusive', eligibility: 'Up to 7 yrs / 70,000 mi' },
  { key: 'prem', name: 'Premier',   eligibility: 'Up to 12 yrs / 120,000 mi' },
  { key: 'dyn',  name: 'Dynamic',   eligibility: 'Up to 15 yrs / 150,000 mi' },
];

const warrantyFirstFeatures = [
  { label: 'All Mechanical Parts',    plans: { exc: true,  prem: false, dyn: false } },
  { label: 'All Electrical Parts',    plans: { exc: true,  prem: false, dyn: false } },
  { label: 'Engine',                  plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Gearbox',                 plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Clutch',                  plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Drive Train',             plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Steering',                plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Suspension',              plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Braking System',          plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Cooling System',          plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Wheel Bearings',          plans: { exc: true,  prem: true,  dyn: true  } },
  { label: 'Wear & Tear Cover',       plans: { exc: true,  prem: true,  dyn: 'Selected parts' } },
  { label: 'Electrical Parts',        plans: { exc: true,  prem: true,  dyn: 'Some' } },
  { label: 'Air Conditioning',        plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'Turbocharger',            plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'ECUs & Computers',        plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'Fuel System',             plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'Ignition System',         plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'Oil Seals & Gaskets',     plans: { exc: true,  prem: true,  dyn: false } },
  { label: 'Flywheel & Drive Plates', plans: { exc: true,  prem: true,  dyn: false } },
];

function CellValue({ value }) {
  if (value === true) {
    return <span className="warranty-cell-check" aria-label="Included">&#10003;</span>;
  }
  if (value === false) {
    return <span className="warranty-cell-none" aria-label="Not included">&mdash;</span>;
  }
  return <span className="warranty-cell-note">{value}</span>;
}

function WarrantyTable({ plans, features }) {
  return (
    <div className="warranty-table-wrap">
      <table className="warranty-table">
        <thead>
          <tr>
            <th className="warranty-table-feature-col">Feature</th>
            {plans.map((plan) => (
              <th key={plan.key} className="warranty-table-plan-col">
                <span className="warranty-table-plan-name">{plan.name}</span>
                <span className="warranty-table-plan-elig">{plan.eligibility}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={feature.label} className={index % 2 === 0 ? 'warranty-table-row-alt' : ''}>
              <td className="warranty-table-feature-label">{feature.label}</td>
              {plans.map((plan) => (
                <td key={plan.key} className="warranty-table-cell">
                  <CellValue value={feature.plans[plan.key]} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function WarrantyPage({ authUser }) {
  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />

      <main className="content-wrap warranty-content-wrap">
        <div className="warranty-main">
          <section className="content-page-block warranty-intro-block">
            <div className="section-header">
              <h2>Warranty</h2>
            </div>
            <p>
              At M.J. Motors we aim to make buying a car as easy and stress-free as possible.
              For added peace of mind we have partnered with two of the UK's leading warranty
              providers — <strong>WarrantyWise</strong> and <strong>Warranty First</strong>.
              A minimum of 3 months warranty is included with every car.
            </p>
          </section>

          <section className="content-page-block warranty-provider-block">
            <div className="warranty-provider-heading">
              <a
                href="https://www.warrantywise.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="warranty-provider-logo-link"
                aria-label="Visit WarrantyWise website"
              >
                <img src={warrantywiseLogo} alt="WarrantyWise" className="warranty-provider-logo" />
              </a>
            </div>
            <p className="warranty-provider-intro">
              WarrantyWise have earned their reputation as the UK's leading warranty provider
              through great cover and fantastic customer relations. Choose from five levels of
              cover to suit your vehicle's age and mileage.
            </p>
            <WarrantyTable plans={warrantyWisePlans} features={warrantyWiseFeatures} />
          </section>

          <section className="content-page-block warranty-provider-block">
            <div className="warranty-provider-heading">
              <a
                href="https://www.warrantyfirst.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="warranty-provider-logo-link"
                aria-label="Visit Warranty First website"
              >
                <img src={warrantyfirstLogo} alt="Warranty First" className="warranty-provider-logo warranty-provider-logo--padded" />
              </a>
            </div>
            <p className="warranty-provider-intro">
              Warranty First provides policies designed to offer similar protection to that
              supplied by the manufacturer when the vehicle was new — protecting you against
              mechanical or electrical breakdown.
            </p>
            <WarrantyTable plans={warrantyFirstPlans} features={warrantyFirstFeatures} />
          </section>
        </div>

        <aside className="warranty-sidebar" aria-label="Warranty contact">
          <section className="content-page-block warranty-side-panel">
            <h3 className="warranty-side-title">Questions?</h3>
            <p className="warranty-side-text">
              Speak with our team about warranty options on any vehicle in stock.
            </p>
            <a className="about-contact-link" href="tel:01782835561">01782 835561</a>
            <a className="about-contact-link" href="mailto:markjeffery1000@yahoo.co.uk">
              markjeffery1000@yahoo.co.uk
            </a>
          </section>

          <section className="content-page-block warranty-side-panel">
            <h3 className="warranty-side-title">Included as Standard</h3>
            <p className="warranty-side-text">
              Every car sold at M.J. Motors includes a minimum of 3 months warranty as
              standard, giving you immediate peace of mind.
            </p>
          </section>

          <section className="content-page-block warranty-side-panel">
            <h3 className="warranty-side-title">Extended Cover</h3>
            <p className="warranty-side-text">
              Extended warranty options are available through WarrantyWise and Warranty First.
              Ask us in store or call for details.
            </p>
          </section>
        </aside>
      </main>
    </div>
  );
}

export default WarrantyPage;
